(function () {
  var THRESHOLD = 35000;

  function updateShippingBar() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var total = data.total_price;
        var textEl = document.getElementById('ms-shipping-text');
        var fillEl = document.getElementById('ms-shipping-fill');
        if (!textEl || !fillEl) return;

        if (total >= THRESHOLD) {
          textEl.textContent = 'Odblokowano darmową dostawę!';
          fillEl.style.width = '100%';
        } else {
          var remaining = ((THRESHOLD - total) / 100).toFixed(0);
          textEl.textContent = 'Do darmowej dostawy brakuje Ci ' + remaining + ' zł';
          fillEl.style.width = Math.min((total / THRESHOLD) * 100, 100) + '%';
        }
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', updateShippingBar);
  document.addEventListener('cart:refresh', updateShippingBar);
  document.addEventListener('cart:updated', updateShippingBar);
  document.addEventListener('cart-update', updateShippingBar);
})();

(function() {
  const origFetch = window.fetch;
  window.fetch = function(url, ...args) {
    return origFetch.call(this, url, ...args).then(async res => {
      const u = typeof url === 'string' ? url : (url?.url || '');
      if ((u.includes('/cart/change') || u.includes('/cart/update')) && res.ok) {
        setTimeout(async () => {
          try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            const priceEl = document.getElementById('ms-checkout-price');
            if (priceEl && cart.total_price !== undefined) {
              const formatted = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' zł';
              priceEl.textContent = formatted;
            }
          } catch(e) {}
        }, 400);
      }
      return res;
    });
  };
})();
